import CustomCard from '@components/CustomCard';
import { Card, Col } from 'antd';
import styled from 'styled-components';

export const DashContainer = styled.div`
  .ant-statistic-content-value {
    font-size: ${({ theme }) => theme.fontSizes.extraLarge} !important;
    line-height: ${({ theme }) => theme.fontSizes.extraLarge} !important;
  }
  .ant-statistic-content-suffix {
    font-size: ${({ theme }) => theme.fontSizes.default} !important;
    line-height: ${({ theme }) => theme.fontSizes.default} !important;
  }
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const CardContainer = styled(Card)`
  canvas {
    max-height: 10rem;
  }
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }
  .card-header {
    .card-title-box {
      display: flex;
      gap: 0.1rem;
      align-items: center;

      .card-title {
        font-weight: 600;
        font-size: 1.1rem;
        white-space: normal;
        word-break: break-spaces;
      }
    }

    .button-tooltip {
      @media (max-width: 584px) {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-right: 5px;
      }
    }

    .anticon-question-circle {
      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors?.text};
      }
    }

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};
    .ant-tabs {
      padding: 0;
    }
    .ant-tabs-tab {
      margin: 0;
      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }
    .ant-radio-group {
      z-index: 0;
    }
    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;
      span {
        font-weight: normal;
      }
    }
    @media (max-width: 500px) {
      justify-content: center;
      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }
  .ant-col {
    color: ${({ theme }) => theme.colors.text1};
  }
  .ant-card-body {
    padding: 16px;
    height: 100%;
    .ant-statistic {
      display: flex;
      flex-direction: column;
    }
    .ant-statistic-title {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSizes.small};
      color: ${({ theme }) => theme.colors.text1};
    }
    .ant-statistic-content {
      display: inline-flex;
      align-items: center;
    }
    .ant-statistic-content-value {
      color: ${({ theme }) => theme.colors.primary};
      font-size: ${({ theme }) => theme.fontSizes.large};
      line-height: ${({ theme }) => theme.fontSizes.large};
    }
    .ant-statistic-content-suffix {
      color: ${({ theme }) => theme.colors.text1};
      font-size: ${({ theme }) => theme.fontSizes.small};
      line-height: ${({ theme }) => theme.fontSizes.small};
    }
  }
`;

export const FiltersContainer = styled.div`
  div {
    margin: 0;
  }
`;

export const CustomColSpeedoMeter = styled(Col)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: space-between !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
`;

export const DashboardContainer = styled.div`
  .ant-col {
    width: 100% !important;
    margin-top: 24px !important;
  }
`;

export const DashboardCardContainer = styled(CustomCard)``;
